/**
 * This bootstrap file is used for both frontend and backend
 */

import _ from 'lodash'
import axios from 'axios'
import swal from 'sweetalert2';
import $ from 'jquery';
import 'popper.js/dist/umd/popper'; // Required for BS4
import 'bootstrap';

/**
 * Font Awesome >=5.1
 *
 * Is recommended import just the icons that you use, for decrease considerably the file size.
 * You can see at next link, how it works: https://github.com/FortAwesome/Font-Awesome/blob/master/UPGRADING.md#no-more-default-imports
 * Also you can import the icons separately on the frontend and backend
 */

import {library, dom} from '@fortawesome/fontawesome-svg-core';
import {
    faFacebookF,
    faLinkedinIn,
    faTwitter,
    faWhatsapp,
    faYoutube
} from '@fortawesome/free-brands-svg-icons';
import {
    faEnvelope,
    faInfoCircle,
    faShareAlt,
    faShoppingBasket,
    faPhone,
    faSearch,
    faQuestionCircle,
    faChevronUp,
    faShareSquare,
    faCheck,
    faTimes,
    faBell
} from '@fortawesome/free-solid-svg-icons';

library.add(
    faFacebookF,
    faLinkedinIn,
    faTwitter,
    faWhatsapp,
    faEnvelope,
    faInfoCircle,
    faShareAlt,
    faShoppingBasket,
    faYoutube,
    faPhone,
    faSearch,
    faQuestionCircle,
    faChevronUp,
    faShareSquare,
    faCheck,
    faTimes,
    faBell
);

// Kicks off the process of finding <i> tags and replacing with <svg>
dom.watch();

/**
 * We'll load jQuery and the Bootstrap jQuery plugin which provides support
 * for JavaScript based Bootstrap features such as modals and tabs. This
 * code may be modified to fit the specific needs of your application.
 */

window.$ = window.jQuery = $;
window.swal = swal;
window._ = _; // Lodash

/**
 * We'll load the axios HTTP library which allows us to easily issue requests
 * to our Laravel back-end. This library automatically handles sending the
 * CSRF token as a header based on the value of the "XSRF" token cookie.
 */

window.axios = axios;
window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

/**
 * Next we will register the CSRF Token as a common header with Axios so that
 * all outgoing HTTP requests automatically have it attached. This is just
 * a simple convenience so we don't have to attach every token manually.
 */

const token = document.head.querySelector('meta[name="csrf-token"]');

if (token) {
    window.axios.defaults.headers.common['X-CSRF-TOKEN'] = token.content;
} else {
    console.error('CSRF token not found: https://laravel.com/docs/csrf#csrf-x-csrf-token');
}

/**
 * Echo exposes an expressive API for subscribing to channels and listening
 * for events that are broadcast by Laravel. Echo and event broadcasting
 * allows your team to easily build robust real-time web applications.
 */

// import Echo from 'laravel-echo'

// window.Pusher = require('pusher-js');

// window.Echo = new Echo({
//     broadcaster: 'pusher',
//     key: process.env.MIX_PUSHER_APP_KEY
//     cluster: process.env.MIX_PUSHER_APP_CLUSTER,
//     encrypted: true
// });
